module.exports = __webpack_public_path__ + "static/media/tutorial-02.c00cd73d.gif";